import { useEffect, useState } from "react";

const NAV = [
  { label: "翻车现场", href: "#feed" },
  { label: "名场面榜", href: "#top" },
  { label: "尴尬瞬间", href: "#awkward" },
  { label: "被怼金句", href: "#quotes" },
  { label: "吃瓜口碑", href: "#reviews" },
  { label: "常见问题", href: "#faq" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/90 backdrop-blur-md shadow-sm" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#home" className="flex items-center gap-2" aria-label="搭讪吃瓜首页">
          <span className="grid h-9 w-9 place-items-center rounded-xl bg-orange-500 text-white">
            <i className="ri-chat-smile-3-line text-xl" />
          </span>
          <span className="font-hand text-xl text-stone-800">
            搭讪<span className="text-orange-500">吃瓜</span>
          </span>
        </a>

        <div className="hidden items-center gap-1 md:flex">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium text-stone-600 transition-colors hover:bg-orange-100 hover:text-orange-600"
            >
              {n.label}
            </a>
          ))}
          <a
            href="#faq"
            className="ml-2 whitespace-nowrap rounded-full bg-stone-900 px-5 py-2 text-sm font-semibold text-white transition-colors hover:bg-stone-700"
          >
            来投稿吃瓜
          </a>
        </div>

        <button
          className="grid h-10 w-10 place-items-center rounded-lg text-stone-700 md:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label="打开菜单"
          aria-expanded={open}
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-4-line"} text-2xl`} />
        </button>
      </nav>

      {open && (
        <div className="border-t border-stone-100 bg-white/95 backdrop-blur-md md:hidden">
          <div className="mx-auto flex max-w-7xl flex-col gap-1 px-4 py-3">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm font-medium text-stone-700 hover:bg-orange-50 hover:text-orange-600"
              >
                {n.label}
              </a>
            ))}
            <a
              href="#faq"
              onClick={() => setOpen(false)}
              className="mt-1 whitespace-nowrap rounded-lg bg-stone-900 px-3 py-2.5 text-center text-sm font-semibold text-white"
            >
              来投稿吃瓜
            </a>
          </div>
        </div>
      )}
    </header>
  );
}